import { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { AccessLevel } from '@/entities/vfo/types';

type AccessLevelPreviewProps = {
  level: AccessLevel;
};

const getAccessLevelPreviewImage = (level: AccessLevel) => {
  switch (level) {
    case AccessLevel.CONNECTED:
      return '/assets/modals/accessLevels/connected.png';
    case AccessLevel.DELEGATED:
      return '/assets/modals/accessLevels/delegated.png';
    case AccessLevel.BASIC:
    default:
      return '/assets/modals/accessLevels/basic.png';
  }
};

export const AccessLevelPreview: FC<AccessLevelPreviewProps> = ({ level }) => {
  const { t } = useTranslation('widgets/modals', {
    keyPrefix: `accessLevelDetails.${level.toLowerCase()}`,
  });
  return (
    <ImageStyled
      src={getAccessLevelPreviewImage(level)}
      width={800}
      height={330}
      alt={t('title')}
    />
  );
};

const ImageStyled = styled(Image)`
  width: 100%;
  height: auto;
  aspect-ratio: 800 / 330;
`;
